<script>
export default {
  functional: true,
  render(h, ctx) {
    return (
      <div class='exercise-set-details-header'>
        <div class='row'>
          <div class='col'>
            <span class='set-details-title'>Reps</span>
          </div>
          <div class='col'>
            <span class='set-details-title'>Time</span>
          </div>
          <div class='col'>
            <span class='set-details-title'>Weight</span>
          </div>
          <div class='col'>
            <span class='set-details-title'>Rest After</span>
          </div>
        </div>
      </div>
    );
  },
};
</script>

<style lang="scss" scoped>
@import '@design';

.exercise-set-details-header {
  border-bottom: 1px solid $color-light-gray;
  padding: 0 0 2.15rem;

  .col {
    text-align: center;
  }

  .set-details-title {
    color: $color-text;
    font-size: 1.2rem;
    font-weight: bold;
    letter-spacing: 1.34675px;
    line-height: 1.6rem;
    text-transform: uppercase;
  }
}
</style>
